import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        biColorHeader: {
            color: theme.palette.grey.header,
        },
        headerSpan: {
            color: theme.palette.primary.main,
        },
    };
});
